export default __webpack_public_path__ + "static/media/clock3d.6f38fcf5.png";